export const eventConstants = {
  GET_EVENT: "GET_EVENT",
  SET_EVENT: "SET_EVENT"
};
